<script setup lang="ts">
import { DgrDialog } from '@stockmarkteam/donguri-ui';

type Props = {
  url: string;
};
defineProps<Props>();

type Emits = {
  submit: [];
};
const emit = defineEmits<Emits>();

// このコンポーネントはDgrDialogをラップしているだけなので、openの値をこのコンポーネント内で変更しない。
const open = defineModel<boolean>('open', { default: false });

const submit = () => emit('submit');
</script>

<template>
  <Teleport to="body">
    <DgrDialog v-model:open="open" title="BOXフォルダURLの削除">
      <template #description>
        <div class="modal-body c-text-regular--m">
          <div>{{ url }}</div>
          <div>を削除しますか？</div>
        </div>
      </template>
      <template #submit>
        <button
          class="c-btn c-btn--auto c-btn--negative submit-button"
          @click="submit"
        >
          削除
        </button>
      </template>
    </DgrDialog>
  </Teleport>
</template>

<style lang="scss" scoped>
.modal-body {
  width: 480px;
  margin-bottom: -7px;
}
.submit-button {
  box-sizing: border-box;
}
</style>
